export default {
    // ========== Labels de campos ==========
    equivalentWeighting: 'Ponderación equivalente',
    lockRaMicroCreation: 'Bloquear creación de {entity} en el {context}',
    selectableIn: 'Es seleccionable en',
    matterCategory: 'Categoría de la asignatura',
    defaultLanguage: 'Idioma de la asignatura',
    noDefaultLanguage: 'Seleccione un idioma',
    defaultLanguagePopoverTitle: 'Vistas afectadas por el idioma',
    defaultLanguagePopoverDesc: 'Al configurar un idioma en la asignatura, las siguientes vistas se mostrarán en ese idioma para los usuarios que accedan a ellas.',
    defaultLanguagePopoverAllInstitutions: 'Disponible para todas las instituciones',
    defaultLanguagePopoverDuocOnly: 'Solo DUOC UC',
    defaultLanguagePopoverEvaluateeNote: 'Al responder o revisar una evaluación',
    defaultLanguageViewsTitle: 'Vistas donde se cambiará el idioma',
    defaultLanguageViewEval: 'Vista de {name}',
    defaultLanguageTeacherView: 'Vista del Profesor en {name} (Evaluador)',
    defaultLanguageStudentView: 'Vista del Estudiante en {name}',
    defaultLanguageOutputFormat: 'Formato de Salida {name}',
    defaultLanguageOutputLearningExp: 'Formato de Salida Experiencias de Aprendizaje',
    defaultLanguageOutputSubjectDesc: 'Formato de Salida Descripción de la Asignatura',
    defaultLanguageOutputPA: 'Formato de Salida PA',
    defaultLanguageOutputPDA: 'Formato de Salida PDA',
    defaultLanguageOutputPIA: 'Formato de Salida PIA',
    planLevel: 'Nivel del plan',
    isCapstoneCourse: 'Asignatura Integradora',
    weeks: 'Semanas',
    students: 'Estudiantes',
    teachers: 'Docentes',
    assistants: 'Ayudantes',

    // ========== Acciones ==========
    automatic: 'Automático',
    planned: 'Planificado',
    lock: 'Bloquear',
    unlock: 'Desbloquear',

    // ========== Tooltips y mensajes ==========
    changesReflectedTooltip: 'Los cambios en este campo se verán reflejados en todas las {entity} vinculadas',
    changesReflectedTooltip2: 'Los cambios en este campo se verán reflejados en todas las {entity}',
    markedFieldsChangesTooltip: 'Los cambios en los campos marcados (⚠️) se verán reflejados en todas las {entity1} vinculadas a esta {entity2}.',
    useEquivalentWeightingTooltip: 'Utilizar una ponderación equivalente para los {entity1} y {entity2}',
    enableRaMicroCreationTooltip: 'Habilita la creación de {entity} directamente en el {context}.',
    enableHoursDistributionTooltip: 'Habilita la distribución de las horas de la {entity} entre los perfiles docentes asignados. Si se desactiva, se podrán asignar horas libremente a cada docente sin exceder el total permitido.',
    allowRaAssignmentTooltip: 'Permite la asignación de un {entity1} ya relacionado a otra {entity2}.',
    evaluationErrorsPopover: 'La {entity} cuenta con algunos errores en las evaluaciones que se deben corregir. Para más información, presione el botón.',
    changeStatusTooltip: 'Cambiar el estado de la {entity}',
    changeStatusOf: 'Cambiar el estado del {entity}',

    lockDescriptorsTooltip: '<b>Bloquear descriptores</b> <br> Esto impedirá que usuarios sin permiso puedan modificar los datos dentro del {entity}',
    unlockDescriptorsTooltip: '<b>Desbloquear descriptores</b> <br> Esto permitirá que los usuarios puedan modificar los datos dentro del {entity}',

    lockTeachingSupportTooltip: '<b>Bloquear Recursos de apoyo a la docencia</b> <br> Esto impedirá que usuarios sin permiso puedan modificar los datos dentro del {entity}',
    unlockTeachingSupportTooltip: '<b>Desbloquear Recursos de apoyo a la docencia</b> <br> Esto permitirá que los usuarios puedan modificar los datos dentro del {entity}',

    lockBibliographicResourcesTooltip: '<b>Bloquear Recursos bibliográficos</b> <br> Esto impedirá que usuarios sin permiso puedan modificar los datos dentro del {entity}',
    unlockBibliographicResourcesTooltip: '<b>Desbloquear Recursos bibliográficos</b> <br> Esto permitirá que los usuarios puedan modificar los datos dentro del {entity}',

    lockTeacherProfilesTooltip: '<b>Bloquear Perfiles de docente(s)</b> <br> Esto impedirá que usuarios sin permiso puedan modificar los datos dentro del {entity}',
    unlockTeacherProfilesTooltip: '<b>Desbloquear Perfiles de docente(s)</b> <br> Esto permitirá que los usuarios puedan modificar los datos dentro del {entity}',

    lockAssistantProfilesTooltip: '<b>Bloquear Perfiles de ayudante</b> <br> Esto impedirá que usuarios sin permiso puedan modificar los datos dentro del {entity}',
    unlockAssistantProfilesTooltip: '<b>Desbloquear Perfiles de ayudante</b> <br> Esto permitirá que los usuarios puedan modificar los datos dentro del {entity}',

    reviewCode: 'Revisar {entity} de la {context}',

    // ========== Validaciones ==========
    fieldMinLength: 'Este campo no debe estar vacío y no debe ser menor a {min} caracteres.',
    existsWithName: 'Existe una {entity} con ese nombre en el {context}',
    cannotCreateBelongsToOther: 'Esta {entity} no se puede crear, ya que pertenece a otra {context} transversal.',
    existsWithSameName: 'Existe una {entity} con ese nombre.',
    alreadyBeingUsed: 'Esta {entity} ya está siendo utilizada.',
    importFromBaseByCodeTitle: '{code_entity} en uso',
    importFromBaseByCode: 'Este {code_entity} pertenece a la {entity} <strong>"{name}"</strong>. ¿Desea asignar sus datos en el formulario?',
    importData: 'Asignar {entity}',
    fieldGreaterThanAndLessOrEqual: 'Este campo debe ser mayor que {min} y menor o igual de {max}',
    mustSelectEntityForEntity: 'Debe seleccionar un {entity1} para la {entity2}.',

    // ========== Modales y mensajes ==========
    selectToUse: 'Seleccione la {entity} que asignará',
    selectCategory: 'Seleccione una categoría.',
    noCategoriesCreated: 'No cuenta con Categorías creadas',

    // ========== Números de campos ==========
    numberOf: 'N° {entity}',
    defineNumberInStudyPlan: 'Define el número de la {entity} en el Plan de Estudio.',

    // ========== Acciones con entidades ==========
    selectEntity: 'Seleccionar {entity}',
    selectBaseDescription: 'Si desea utilizar una {entity} como referencia, puede seleccionarla a continuación. Algunos de sus datos se asignarán automáticamente en este formulario.',
    linkEntity: 'Vincular {entity}',
    clearNameAndEntity: 'Limpiar nombre y {entity}',

    // ========== Mensajes de disponibilidad ==========
    verifyEntityAvailable: 'Verifique que la {entity} esté disponible en la plataforma',
    occupied: 'ocupada',

    // ========== Mensajes de ponderación y evaluación ==========
    cannotChangeWeightingClosedEvaluations: 'No puede cambiar la Ponderación Equivalente dado que existen evaluaciones ya cerradas. Si aún así desea cambiar la Ponderación presione el botón y abra las Evaluaciones que se indicarán en la ventana',

    // ========== Distribución de horas ==========
    distributeCoTeachingHours: 'Distribuir horas de co-docencia',
    distributeTeacherProfileHours: 'Distribuir las horas de los Perfiles de Docentes',

    // ========== Cálculos y fórmulas ==========
    hoursPerCredit: 'Horas por',
    necessaryForRegistration: 'Necesario para su registro en {entity}',
    necessaryForShow: 'Necesario para que pueda aparecer para seleccionar en {entity}',
    changeWeeksWarning: 'Al cambiar la cantidad de semana, modificara la cantidad Total de {entity1} y {entity2}.',
    shares: 'Comparte',
    isExemptable: 'Eximible',

    // ========== Navegación y redirección ==========
    goToCurricularDefinitions: 'Diríjase a Definiciones Curriculares para poder crear {entity}',

    // ========== Estados e información ==========
    informationToComplete: 'Información por Completar',
    closedEvaluations: 'Evaluaciones cerradas',
    currentlyEntityLocked: 'Actualmente los {entity} se encuentran bloqueados',

    // ========== Tabs y secciones ==========
    descriptors: 'Descriptores',
    teachingSupportResources: 'Recursos de apoyo a la docencia',
    bibliographicResources: 'Recursos bibliográficos',
    teacherProfiles: 'Perfiles de docente(s)',
    assistantProfiles: 'Perfiles de ayudante(s)',

    // ========== Confirmaciones y alertas ==========
    notAssignedAnyEntity: 'Teniendo en cuenta que no ha asignado ninguna {entity}',
    sureToCloseEntity: '¿Está seguro de que desea cerrar la {entity}?',
    assignPrerequisitesMessage: 'Para poder asignar los prerrequisitos que provienen desde la <strong>{entity1} Transversal</strong>, es necesario que se cree primero la{plural1} siguiente{plural2} <strong>{entity2}:</strong> "<strong>{matters}</strong>"',
    alreadyHasEntityInProfile: 'En este {entity1} ya cuenta con la {entity2} seleccionada en "{wrapper}".',
    alreadyHasEntitySelected: 'En este {entity1} ya cuenta con la {entity2} seleccionada.',

    // ========== Popover Vincular Asignatura Base ==========
    linkEntityPopoverTitle: '¿Qué implica vincular la {entity}?',
    linkEntityLinkedTitle: 'Vinculada (Sí)',
    linkEntityLinkedDesc: 'La {entity1} del {entity2} toma y comparte los datos de la {entity3}.',
    linkEntityLinkedItems: 'Horas y asignaciones de tiempo|Créditos y créditos institucionales|Semanas|Modalidades y ambientes de estudio|Tipos de asignatura|Descriptores|Evaluaciones',
    linkEntityLinkedWarning: 'Los cambios afectan a TODAS las {entity} que usen esta misma base y que estén vinculadas.',
    linkEntityIndependentTitle: 'No vinculada (No)',
    linkEntityIndependentDesc: 'La {entity1} tendrá sus propios valores independientes en el {entity2}.',
    linkEntityIndependentItems: 'Horas y asignaciones de tiempo propias|Créditos calculados desde horas propias|Semanas propias|Modalidades y ambientes propios|Tipos de asignatura propios|Descriptores propios|Evaluaciones propias',
    linkEntityIndependentInfo: 'Los cambios solo afectan a esta {entity1} en este {entity2}.',
    linkEntityCopyNote: 'Al desvincular, se copian los valores actuales de la base como punto de partida.',
    linkEntityAlwaysOwnTitle: 'Siempre propio de la {entity}',
    linkEntityAlwaysOwnDesc: 'Los siguientes datos son siempre específicos de la {entity1} dentro de su {entity2}, independientemente de si está vinculada o no:',
    linkEntityAlwaysOwnItemName: 'Nombre en el {entity}',
    linkEntityAlwaysOwnItemWeighing: 'Ponderación en la malla',
    linkEntityAlwaysOwnItemCompetences: 'Competencias a las que tributa',

    // ========== Datos que se conservan al seleccionar asignatura base ==========
    preservedDataTitle: 'Datos que se conservan de la {entity}',
    preservedDataDesc: 'Al seleccionar una {entity}, los siguientes datos serán asignados:',

    // ========== Formulario OldMatterForm ==========
    existingEntity: 'Existente',
    thisEntityDoesNotHave: 'Este {entity1} no cuenta con {entity2} creadas',
    savedSuccessfully: 'Cambios guardados correctamente.',
    createdSuccessfully: '{entity} creada correctamente.',
    eliminatedSuccessfully: '{entity} eliminada.',

    // ========== Créditos PUCV ==========
    pucvCreditsReference: 'Equivale a {sct} créditos SCT, {weekly_hours} horas pedagógicas PUCV (35 min) semanales y hasta {hours} en {weeks} semanas.',
    pucvHoursExceeded: 'El total de horas ({total} horas pedagógicas PUCV) supera las {max} que corresponden a {credits} {entity}.',
    pucvSctMismatch: 'Según la PUCV, {credits} {entity} equivalen a {sct} créditos SCT (× 1,5).',
}
